(function() {
  'use strict';

  function getCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(cookie.slice(prefix.length));
        } catch (error) {
          return cookie.slice(prefix.length);
        }
      }
    }

    return '';
  }

  function setCookie(name, value, hours) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (hours * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  function parseAffiliateRules(rawRules) {
    return String(rawRules || '').split(/\r?\n/).map(function(line) {
      var trimmed = line.trim();
      var separatorIndex;

      if (!trimmed || trimmed.charAt(0) === '#') {
        return null;
      }

      separatorIndex = trimmed.indexOf('|');
      if (separatorIndex < 0) separatorIndex = trimmed.indexOf(',');
      if (separatorIndex < 0) separatorIndex = trimmed.indexOf('=');
      if (separatorIndex < 0) return null;

      var pattern = trimmed.slice(0, separatorIndex).trim();
      var name = trimmed.slice(separatorIndex + 1).trim();
      return pattern && name ? { pattern: pattern, name: name } : null;
    }).filter(Boolean);
  }

  function normalizedAffiliatePattern(pattern) {
    var normalized = String(pattern || '').trim().toLowerCase();

    if (/^www\./.test(normalized)) normalized = 'https://' + normalized;
    if (normalized.indexOf('://') > -1) {
      try {
        var parsed = new URL(normalized);
        normalized = parsed.pathname;
      } catch (error) {
        return normalized;
      }
    } else {
      normalized = normalized.split(/[?#]/)[0];
    }

    return normalized;
  }

  function findAffiliateName(rawRules) {
    var rules = parseAffiliateRules(rawRules);
    var currentPath = window.location.pathname.toLowerCase();

    for (var index = 0; index < rules.length; index += 1) {
      var normalized = normalizedAffiliatePattern(rules[index].pattern);
      if (normalized && currentPath.indexOf(normalized) > -1) {
        return rules[index].name;
      }
    }

    return '';
  }

  function cleanNavigationText(value) {
    return String(value || '')
      .replace(/[\u2192\u203a]+\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function navigationDevice() {
    return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches ? 'mobile' : 'desktop';
  }

  function navigationKey(value) {
    return cleanNavigationText(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'main';
  }

  function pushNavigationEvent(eventName, details) {
    var navLocation = details.location || 'header';
    var navMenu = details.menu || navigationKey(details.section || 'main');
    var navItem = details.item || '';
    var navDestination = details.url || '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      nav_location: navLocation,
      nav_device: navigationDevice(),
      nav_level: details.level || '',
      nav_component: details.component || 'link',
      nav_menu: navMenu,
      nav_item: navItem,
      nav_destination: navDestination,
      navigation_name: 'kion_global_navigation',
      navigation_variant: 'new_navigation',
      navigation_item: navItem,
      navigation_section: details.section || '',
      navigation_level: details.level || '',
      navigation_device: navigationDevice(),
      navigation_interaction: details.interaction || '',
      link_url: navDestination
    });
  }

  function initTopbar(bar) {
    if (!bar || bar.dataset.slInitialized === 'true') return;
    bar.dataset.slInitialized = 'true';

    var regularMessages = Array.prototype.slice.call(bar.querySelectorAll('[data-sl-topbar-message]:not([data-sl-affiliate-message])'));
    var affiliateMessage = bar.querySelector('[data-sl-affiliate-message]');
    var prevButton = bar.querySelector('[data-sl-topbar-prev]');
    var nextButton = bar.querySelector('[data-sl-topbar-next]');
    var affiliateName = findAffiliateName(bar.dataset.affiliateRules || '') || getCookie('kion_affiliate');
    var previewName = bar.dataset.affiliatePreviewName || '';
    var isPreview = bar.dataset.affiliatePreview === 'true';
    var messages = regularMessages;
    var activeIndex = 0;
    var timer = null;
    var interval = Math.max(3, Number(bar.dataset.rotationSeconds) || 5) * 1000;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!affiliateName && isPreview) affiliateName = previewName;

    if (affiliateName && affiliateMessage) {
      var matchedName = findAffiliateName(bar.dataset.affiliateRules || '');
      var cookieHours = Number(bar.dataset.affiliateCookieHours) || 3;
      if (matchedName) setCookie('kion_affiliate', matchedName, cookieHours);

      regularMessages.forEach(function(message) { message.classList.remove('is-active'); });
      affiliateMessage.textContent = String(bar.dataset.affiliateTemplate || 'Final [affiliate] discount will apply at checkout!')
        .replace(/\[affiliate\]|\{affiliate\}/gi, affiliateName);
      affiliateMessage.classList.add('is-active');
      messages = [affiliateMessage];
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
    }

    if (!messages.length) {
      bar.hidden = true;
      return;
    }

    if (messages.length === 1) {
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
    }

    function showMessage(index) {
      messages.forEach(function(message, messageIndex) {
        message.classList.toggle('is-active', messageIndex === index);
        message.setAttribute('aria-hidden', messageIndex === index ? 'false' : 'true');
      });
      activeIndex = index;
    }

    function move(direction) {
      showMessage((activeIndex + direction + messages.length) % messages.length);
    }

    function stopRotation() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startRotation() {
      stopRotation();
      if (messages.length > 1 && !reducedMotion) {
        timer = window.setInterval(function() { move(1); }, interval);
      }
    }

    if (!affiliateName) showMessage(0);
    if (prevButton) prevButton.addEventListener('click', function() { move(-1); startRotation(); });
    if (nextButton) nextButton.addEventListener('click', function() { move(1); startRotation(); });
    bar.addEventListener('mouseenter', stopRotation);
    bar.addEventListener('mouseleave', startRotation);
    bar.addEventListener('focusin', stopRotation);
    bar.addEventListener('focusout', startRotation);
    bar.addEventListener('click', function(event) {
      var link = event.target.closest('a');
      if (!link || !bar.contains(link)) return;
      pushNavigationEvent('navigation_click', {
        location: 'announcement_bar',
        item: cleanNavigationText(link.textContent),
        section: 'Announcement bar',
        level: 'utility',
        component: 'announcement_link',
        menu: 'announcement_bar',
        interaction: 'click',
        url: link.href || link.getAttribute('href') || ''
      });
    });
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) stopRotation(); else startRotation();
    });
    startRotation();
  }

  function initHeader(root) {
    if (!root || root.dataset.slInitialized === 'true') return;
    root.dataset.slInitialized = 'true';
    document.body.classList.add('sl-nav-test-active');

    var menuButton = root.querySelector('[data-sl-mobile-toggle]');
    var drawer = root.querySelector('[data-sl-mobile-drawer]');
    var mainPanel = root.querySelector('[data-sl-mobile-main]');
    var shopAllPanel = root.querySelector('[data-sl-mobile-shop-all]');
    var shopAllButton = root.querySelector('[data-sl-open-shop-all]');
    var backButton = root.querySelector('[data-sl-back-main]');
    var searchButtons = root.querySelectorAll('[data-sl-search-toggle]');
    var searchPanel = root.querySelector('[data-sl-search-panel]');
    var searchForm = root.querySelector('.sl-nav-test__search-form');
    var searchClose = root.querySelector('[data-sl-search-close]');
    var searchInput = root.querySelector('[data-sl-search-input]');
    var megaTrigger = root.querySelector('[data-sl-mega-trigger]');
    var megaPanel = root.querySelector('[data-sl-mega-panel]');
    var navArea = root.querySelector('[data-sl-desktop-nav-area]');
    var desktopDirectLinks = root.querySelectorAll('.sl-nav-test__desktop-link');
    var cartCounts = root.querySelectorAll('[data-sl-cart-count]');
    var closeTimer = null;

    function navigationHeading(element) {
      var group = element.closest('.sl-nav-test__product-group');
      var secondary = element.closest('.sl-nav-test__mega-secondary');
      var sibling;

      if (group) {
        var groupHeading = group.querySelector('.sl-nav-test__mega-heading');
        return groupHeading ? cleanNavigationText(groupHeading.textContent) : 'Shop All';
      }

      if (secondary) {
        var secondaryHeading = secondary.querySelector('.sl-nav-test__mega-heading');
        return secondaryHeading ? cleanNavigationText(secondaryHeading.textContent) : 'Shop All';
      }

      if (element.closest('[data-sl-mobile-shop-all]')) {
        sibling = element.previousElementSibling;
        while (sibling) {
          if (sibling.classList.contains('sl-nav-test__mobile-heading')) {
            return cleanNavigationText(sibling.textContent);
          }
          sibling = sibling.previousElementSibling;
        }
      }

      return 'Shop All';
    }

    function navigationLinkDetails(element) {
      var labelElement;
      var details = {
        item: '',
        section: 'utility',
        level: 'utility',
        component: 'utility_link',
        menu: 'utility',
        interaction: 'click',
        url: element.href || element.getAttribute('href') || ''
      };

      if (element.classList.contains('sl-nav-test__desktop-link') || element.classList.contains('sl-nav-test__mobile-link')) {
        labelElement = element.querySelector('.sl-nav-test__mobile-title');
        details.section = 'Primary navigation';
        details.level = 'primary';
        details.component = 'primary_link';
        details.menu = 'main';
      } else if (element.classList.contains('sl-nav-test__product-card') || element.classList.contains('sl-nav-test__mobile-product')) {
        labelElement = element.querySelector('.sl-nav-test__product-name, .sl-nav-test__supplement-title');
        details.section = navigationHeading(element);
        details.level = 'product';
        details.component = 'product_card';
        details.menu = navigationKey(details.section);
      } else if (element.classList.contains('sl-nav-test__secondary-link') || element.classList.contains('sl-nav-test__mobile-simple')) {
        labelElement = element.querySelector('.sl-nav-test__secondary-name, span');
        details.section = navigationHeading(element);
        details.level = 'secondary';
        details.component = 'submenu_link';
        details.menu = navigationKey(details.section);
      } else if (element.classList.contains('sl-nav-test__view-all') || element.classList.contains('sl-nav-test__view-all-mobile')) {
        details.section = navigationHeading(element);
        details.level = 'cta';
        details.component = 'submenu_link';
        details.menu = navigationKey(details.section);
      } else if (element.classList.contains('sl-nav-test__promo-card') || element.classList.contains('sl-nav-test__promo-link')) {
        labelElement = element.querySelector('.sl-nav-test__promo-title');
        details.section = 'Promotion';
        details.level = 'promo';
        details.component = 'promo_card';
        details.menu = 'promotion';
      } else if (element.classList.contains('sl-nav-test__logo')) {
        details.item = 'Kion home';
        details.component = 'logo';
      } else if (element.classList.contains('sl-nav-test__cart')) {
        details.item = 'Shopping cart';
        details.component = 'cart';
      } else if (element.classList.contains('sl-nav-test__icon-button')) {
        details.component = 'account';
      }

      if (!details.item) {
        details.item = cleanNavigationText(
          labelElement ? labelElement.textContent : element.getAttribute('aria-label') || element.textContent
        );
      }

      return details;
    }

    function updateMobileOffset() {
      var rootBottom = Math.max(0, Math.round(root.getBoundingClientRect().bottom));
      root.style.setProperty('--sl-nav-mobile-top', rootBottom + 'px');
    }

    function showMainPanel() {
      if (mainPanel) mainPanel.hidden = false;
      if (shopAllPanel) shopAllPanel.hidden = true;
      if (drawer) drawer.scrollTop = 0;
    }

    function showShopAllPanel() {
      if (mainPanel) mainPanel.hidden = true;
      if (shopAllPanel) shopAllPanel.hidden = false;
      if (drawer) drawer.scrollTop = 0;
      if (backButton) backButton.focus();
    }

    function closeMobile() {
      root.classList.remove('is-mobile-open');
      document.body.classList.remove('sl-nav-test-locked');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      showMainPanel();
    }

    function toggleMobile() {
      var shouldOpen = !root.classList.contains('is-mobile-open');
      closeSearch();
      closeMega();
      root.classList.toggle('is-mobile-open', shouldOpen);
      document.body.classList.toggle('sl-nav-test-locked', shouldOpen);
      if (menuButton) menuButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      if (drawer) drawer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      if (shouldOpen) {
        updateMobileOffset();
        pushNavigationEvent('navigation_click', {
          item: 'Mobile menu',
          section: 'Primary navigation',
          level: 'drawer',
          component: 'menu_trigger',
          menu: 'main',
          interaction: 'click'
        });
      } else {
        showMainPanel();
      }
    }

    function openSearch() {
      closeMobile();
      closeMega();
      root.classList.add('is-search-open');
      searchButtons.forEach(function(button) { button.setAttribute('aria-expanded', 'true'); });
      if (searchPanel) searchPanel.setAttribute('aria-hidden', 'false');
      window.setTimeout(function() { if (searchInput) searchInput.focus(); }, 20);
    }

    function closeSearch() {
      root.classList.remove('is-search-open');
      searchButtons.forEach(function(button) { button.setAttribute('aria-expanded', 'false'); });
      if (searchPanel) searchPanel.setAttribute('aria-hidden', 'true');
    }

    function toggleSearch() {
      if (root.classList.contains('is-search-open')) {
        closeSearch();
      } else {
        openSearch();
        pushNavigationEvent('navigation_click', {
          item: 'Search',
          section: 'Utility navigation',
          level: 'utility',
          component: 'search',
          menu: 'utility',
          interaction: 'click'
        });
      }
    }

    function openMega() {
      if (window.innerWidth < 1025) return;
      if (closeTimer) window.clearTimeout(closeTimer);
      closeSearch();
      root.classList.add('is-mega-open');
      document.body.classList.add('sl-nav-mega-open');
      if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'true');
      if (megaPanel) megaPanel.setAttribute('aria-hidden', 'false');
    }

    function closeMega() {
      if (closeTimer) window.clearTimeout(closeTimer);
      root.classList.remove('is-mega-open');
      document.body.classList.remove('sl-nav-mega-open');
      if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'false');
      if (megaPanel) megaPanel.setAttribute('aria-hidden', 'true');
    }

    function scheduleMegaClose() {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeMega, 120);
    }

    function updateCartCount() {
      if (!cartCounts.length) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(response) { return response.ok ? response.json() : Promise.reject(response); })
        .then(function(cart) {
          var count = Number(cart.item_count) || 0;
          cartCounts.forEach(function(cartCount) {
            cartCount.textContent = count;
            cartCount.classList.toggle('is-visible', count > 0);
            cartCount.setAttribute('aria-label', count + (count === 1 ? ' item in cart' : ' items in cart'));
          });
        })
        .catch(function() {});
    }

    if (menuButton) menuButton.addEventListener('click', toggleMobile);
    if (shopAllButton) {
      shopAllButton.addEventListener('click', function() {
        var shopAllLabel = shopAllButton.querySelector('.sl-nav-test__mobile-title');
        showShopAllPanel();
        pushNavigationEvent('navigation_click', {
          item: cleanNavigationText(shopAllLabel ? shopAllLabel.textContent : shopAllButton.textContent),
          section: 'Primary navigation',
          level: 'drilldown',
          component: 'menu_trigger',
          menu: 'main',
          interaction: 'click'
        });
      });
    }
    if (backButton) backButton.addEventListener('click', function() { showMainPanel(); if (shopAllButton) shopAllButton.focus(); });
    searchButtons.forEach(function(button) { button.addEventListener('click', toggleSearch); });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchForm) {
      searchForm.addEventListener('submit', function() {
        pushNavigationEvent('navigation_click', {
          item: 'Search',
          section: 'Utility navigation',
          level: 'utility',
          component: 'search',
          menu: 'utility',
          interaction: 'submit',
          url: searchForm.action || ''
        });
      });
    }

    root.addEventListener('click', function(event) {
      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      pushNavigationEvent('navigation_click', navigationLinkDetails(link));
    });

    if (megaTrigger) {
      megaTrigger.addEventListener('click', function(event) {
        event.preventDefault();
        pushNavigationEvent('navigation_click', {
          item: cleanNavigationText(megaTrigger.textContent || 'Shop All'),
          section: 'Primary navigation',
          level: 'mega_menu',
          component: 'menu_trigger',
          menu: 'main',
          interaction: 'click'
        });
        openMega();
      });
      megaTrigger.addEventListener('mouseenter', openMega);
      megaTrigger.addEventListener('focus', openMega);
    }
    desktopDirectLinks.forEach(function(link) {
      link.addEventListener('mouseenter', closeMega);
      link.addEventListener('focus', closeMega);
    });
    if (navArea) {
      navArea.addEventListener('mouseenter', function() { if (root.classList.contains('is-mega-open')) openMega(); });
      navArea.addEventListener('mouseleave', scheduleMegaClose);
    }
    if (megaPanel) {
      megaPanel.addEventListener('mouseenter', openMega);
      megaPanel.addEventListener('mouseleave', scheduleMegaClose);
    }

    document.addEventListener('click', function(event) {
      if (!root.contains(event.target)) {
        closeMega();
        closeSearch();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeMobile();
        closeMega();
        closeSearch();
        if (menuButton && window.innerWidth < 1025) menuButton.focus();
      }
    });

    window.addEventListener('resize', function() {
      updateMobileOffset();
      if (window.innerWidth >= 1025) closeMobile(); else closeMega();
    });
    window.addEventListener('scroll', updateMobileOffset, { passive: true });

    ['cart:updated', 'cart:refresh', 'rebuy:cart.change', 'rebuy.cart.change', 'rebuy:smartcart.ready'].forEach(function(eventName) {
      document.addEventListener(eventName, function() { window.setTimeout(updateCartCount, 50); });
    });

    updateMobileOffset();
    updateCartCount();
  }

  function initialize() {
    document.querySelectorAll('[data-sl-topbar]').forEach(initTopbar);
    document.querySelectorAll('[data-sl-nav-test]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
